document.addEventListener("DOMContentLoaded", function() {

    changeOptions();

    function changeOptions() {
        var options = document.querySelectorAll(".select select");
        var swatches = document.querySelectorAll("input.lm-variant-swatch-item");
        
        options.forEach(item => {
            item.addEventListener("change", function(event) {
            const selectOption = this.closest(".select").querySelector(".ml-var-opt-value[data-option-value='" + this.value + "']");
            console.log("selectOption", selectOption);

            onVariantChange(selectOption);
            });
        });


        swatches.forEach(item => {
            item.addEventListener("change", function(event) {
            console.log("selectOption", this.value);

            onVariantChange(this);
            });
        });
    }

    function onVariantChange(event) {
        const productElement = document.querySelector("#product");
        const sectionId = productElement.dataset.sectionId;

        if(event.dataset.productUrl == "") {
            return;
        }

        // Combined listings: We use old and new product urls to determine if the product should change
        const oldProductUrl = productElement.dataset.productUrl;
        const newProductUrl = event.dataset.productUrl;

        console.log("oldProductUrl", oldProductUrl);
        console.log("newProductUrl", newProductUrl);

        // Get the selected option value IDs and format as query param
        // const selectedOptionValues = Array.from(
        //   optionValueSelectors.querySelectorAll('fieldset input:checked')
        //   ).map(({dataset}) => dataset.optionValueId);
        // const params = selectedOptionValues.length > 0
        //   ? `&option_values=${selectedOptionValues.join(',')}`
        //   : '';

        // Deferred variants: Fetch the option value picker with the new availability state when remaining on the same product
        // Combined listings: Fetch the product associated with the selected option value and replace the entire product if switching to a sibling product
        fetch(`${newProductUrl}?section_id=${sectionId}`)
        .then((response) => response.text())
        .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');

            // Combined listings: If the product changed, replace the old product section with the new product section
            if (newProductUrl && oldProductUrl !== newProductUrl) {
                productElement.parentNode.append(html.querySelector('#product'), productElement);
                productElement.remove();

                document.querySelector("#product .product_form").classList.add("is-visible");

                // Focus the input for the last clicked option value
                changeOptions();
                initAccordion();
                initMediaGallery();

                // window.scrollTo({
                //     top: 0,
                //     behavior: 'smooth',
                // });
                return;
            }

            // Update any other sections that depend on the option value picker
        });
    }

    function initAccordion() {
        $(".accordion").on("click", function() {
        $(this).parent().toggleClass('active-color');
        $(this).toggleClass("active");
        $(this).next().slideToggle(200);
        });
    }

    function initMediaGallery() {
        var arrowShape = 'M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z';
        
        var main_gallery = $(".product-gallery__main").flickity({
            initialIndex: 0,
            wrapAround: true,
            adaptiveHeight: true,
            dragThreshold: 10,
            imagesLoaded: true,
            pageDots: false,
            prevNextButtons: $(".product-gallery__main").data('media-count') > 1 ? true : false,
            watchCSS: false,
            arrowShape: arrowShape
        });


        var gallery__thumbnails = $(".product-gallery__thumbnails").flickity({
            asNavFor : '.product-gallery__main',
            cellAlign: 'center',
            contain: true,
            groupCells: '80%',
            imagesLoaded: true,
            pageDots: false,
            prevNextButtons: $(".product-gallery__thumbnails .product-gallery__thumbnail").length > 4 ? true : false,
            arrowShape: arrowShape
        });

    }

});
